export const FILE_CONFIG = [
  {
    name: 'Wire List',
    id: 'defPlugin.wireList',
    key: 'wire_export_file',
  },
  {
    name: 'Signal',
    id: 'defPlugin.signal',
    key: 'signal_export_file',
  },
  //   {
  //     name: 'Inline Connectors',
  //     key: 'inline_connector_export_file',
  //   },
  {
    name: 'Harness Description',
    id: 'defPlugin.harnessDescription',
    key: 'harness_description_export_file',
  },
  {
    name: 'Connector',
    id: 'defPlugin.connector',
    key: 'connector_export_file',
  },
]
